import { VIcon } from 'vuetify/lib'
import { commonValidateRule } from '../utils'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
export default {
    computed: {
        fields() {
            const _this = this
            return [
                {
                    label: '合同收支类型',
                    key:'balance_type',
                    type: 'radio_buttons',
                    required: true,
                    rules:[commonValidateRuleGo],
                    cols: 4,
                    items: [
                        {
                            key: 'expense',
                            label: '支出类合同',
                            value: 'expense'
                        },
                        {
                            key: 'income',
                            label: '收入类合同',
                            value: 'income'
                        },
                        {
                            key: 'expense_income',
                            label: '有收有支合同',
                            value: 'expense_income'
                        }
                    ],
                    change() {
                       _this.params.main_type = null
                    },
                    scopedSlots: {
                        label: () => {
                            return <div>
                                <span class={styles['mg-r']}>合同收支类型</span>
                                <VIcon 
                                    size="20"
                                    color={_this.show_type ? 'primary' : ''}
                                    class={styles['cursor']}
                                    on={{
                                        click:() => {
                                            _this.show_type = !_this.show_type
                                        }
                                    }}
                                    >mdi-alert-circle-outline</VIcon>
                            </div>
                        }
                    }
                },
                {
                    key: 'hint',
                    cols: 8,
                },
                {
                    label: '合同属性',
                    key:'contract_attrs',
                    type: 'radio_buttons',
                    cols: 4,
                    required: true,
                    rules:[commonValidateRuleGo],
                    items: [
                        {
                            key: 'zhichulei',
                            label: '框架协议',
                            value: 'zhichulei'
                        },
                        {
                            key: 'shourulei',
                            label: '开口合同',
                            value: 'shourulei'
                        },
                        {
                            key: 'youshouyouzhi',
                            label: '闭口合同',
                            value: 'youshouyouzhi'
                        }
                    ],
                    scopedSlots: {
                        label: () => {
                            return <div>
                                <span class={styles['mg-r']}>合同属性</span>
                                <VIcon 
                                    size="20"
                                    color={_this.show_type ? 'primary' : ''}
                                    class={styles['cursor']}
                                    on={{
                                        click:() => {
                                            _this.show_type = !_this.show_type
                                        }
                                    }}
                                    >mdi-alert-circle-outline</VIcon>
                            </div>
                        }
                    },
                    
                },
                {
                    key: 'hint_1',
                    cols: 8,
                },
                {
                    label: '合同属性',
                    key:'main_type',
                    type: 'autocompletes',
                    rules:[commonValidateRuleGo],
                    required: true,
                    items: this.attrs_list,
                    'item-value':'balance_type',
                    'item-text':'balance_type_name',
                }
            ]
        }
    }
}